// Hook odpowiedzialny za pobranie artykułów z bazy wiedzy

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';

interface IArticleFieldFileTranslation {
  language: string;
  url?: string; // Backend zwraca pełny URL obrazka
  dir?: string;
  stored_filename?: string;
  name?: string;
  description?: string;
  sys_insert_date?: string;
}

interface IArticleFieldFile {
  translations?: IArticleFieldFileTranslation[];
  iterator?: IArticleFieldFileTranslation[];
}

interface IArticleField {
  section_field_id: number;
  field_name?: string;
  section_field_symbol?: string;
  value: string | any[];
  file: IArticleFieldFile | null;
}

export interface IKnowledgeBaseArticle {
  section_id_symbol: string;
  symbol: string;
  id: number;
  title: string;
  subtitle?: string | null;
  content?: string | null;
  layouts: string | null;
  article_fields: IArticleField[];
  lp?: number;
  sys_insert_date?: string;
  url_key?: string | null;
}

// parametry requestu do api
export type IRequest = IPaginationRequest & {
  sort_by?: 'created_at' | 'updated_at';
  sort_order?: 'asc' | 'desc';
};

// typ zwracanych danych
type IResponse = IPaginationResponse<IKnowledgeBaseArticle>;

const getKnowledgeBaseArticles = (params?: IRequest): Promise<IResponse> =>
  axios.get('/cms/knowledge-base/articles', { params });

export const useGetKnowledgeBaseArticles = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['knowledge-base-articles', params],
    () => getKnowledgeBaseArticles(params),
    options
  );

